import { z } from 'zod'
import { ContentfulCurrencyCodesSchema } from './common'

export const ContentfulAmountSchema = z.object({
  amount: z.number().min(0),
  currencyCode: ContentfulCurrencyCodesSchema,
})

export type ContentfulAmount = z.infer<typeof ContentfulAmountSchema>
